import router from '../../router';
// initial state
const state = {
  all: [],
  user: {},
  users: [],
  mowers: []
}

// getters
const getters = {}

// actions
const actions = {
  getUsers ({ commit }) {
    axios
      .get("/admin/users")
      .then(response => (commit('setUsers', response.data)));
  },
  getUser({ commit }, params) {
    axios
      .get("/admin/users/"+params.id)
      .then(response => (commit('setUser', response.data)));
  },
  deleteUser ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .delete("/admin/users/"+params.id, params)
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  setRoles ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/admin/users/"+params.id+"/roles", params)
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
}

// mutations
const mutations = {
  setUsers (state, data) {
    state.all = data.data;
    _.forEach(data.data, (user) => {
      if (user.account_type == 'user') {
        state.users.push(user)
      } else if (user.account_type == 'mower') {
        state.mowers.push(user)
      }
    })
  },
  setUser (state, data) {
    state.user = data.data;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
